export enum DesignTypeEnum {
  Page = 'normal',
  JobAdPage = 'jobad',
  WebDocument = 'webDocument',
  Email = 'email',
  CustomList = 'customList'
}
